import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const UploadIcon: React.FunctionComponent<IconProps> = ({
  width = 18,
  height = 18,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={24} viewBoxHeight={24} {...rest}>
    <path d="M0 0h24v24H0z" fill={'none'} />
    <path d="M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/ui/icon/upload.icon.tsx